module.exports = __webpack_public_path__ + "img/email.87af4588.svg";